import usePageTour from '../../hooks/usePageTour';
import { resolvePageTourKey } from '../../config/tourSteps';

const RouteTourRegistration = ({ pathname }) => {
  usePageTour(resolvePageTourKey(pathname));
  return null;
};

export default RouteTourRegistration;
